const faqQuestions = document.querySelectorAll('.faq__question');
const faqAnswers = document.querySelectorAll('.faq__answer');

if (faqAnswers.length > 0) {
	faqAnswers.forEach(answer => {
		answer.classList.remove('active');
	});
}

if (faqQuestions.length > 0) {
	faqQuestions.forEach(question => {
		question.addEventListener('click', function() {
			const faqItem = this.closest('.faq__item');
			const faqAnswer = this.nextElementSibling;
			
			this.classList.toggle('active');
			faqItem.classList.toggle('active');
			faqAnswer.classList.toggle('active');
		});
	});
}